function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/*
Stimulus 3.2.1
Copyright © 2022 Basecamp, LLC
 */
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.Stimulus = {}));
})(this, function (exports) {
  'use strict';

  var EventListener = /*#__PURE__*/function () {
    function EventListener(eventTarget, eventName, eventOptions) {
      _classCallCheck(this, EventListener);

      this.eventTarget = eventTarget;
      this.eventName = eventName;
      this.eventOptions = eventOptions;
      this.unorderedBindings = new Set();
    }

    _createClass(EventListener, [{
      key: "connect",
      value: function connect() {
        this.eventTarget.addEventListener(this.eventName, this, this.eventOptions);
      }
    }, {
      key: "disconnect",
      value: function disconnect() {
        this.eventTarget.removeEventListener(this.eventName, this, this.eventOptions);
      }
    }, {
      key: "bindingConnected",
      value: function bindingConnected(binding) {
        this.unorderedBindings.add(binding);
      }
    }, {
      key: "bindingDisconnected",
      value: function bindingDisconnected(binding) {
        this.unorderedBindings.delete(binding);
      }
    }, {
      key: "handleEvent",
      value: function handleEvent(event) {
        var extendedEvent = extendEvent(event);

        var _iterator = _createForOfIteratorHelper(this.bindings),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var binding = _step.value;

            if (extendedEvent.immediatePropagationStopped) {
              break;
            } else {
              binding.handleEvent(extendedEvent);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, {
      key: "hasBindings",
      value: function hasBindings() {
        return this.unorderedBindings.size > 0;
      }
    }, {
      key: "bindings",
      get: function get() {
        return Array.from(this.unorderedBindings).sort(function (left, right) {
          var leftIndex = left.index,
              rightIndex = right.index;
          return leftIndex < rightIndex ? -1 : leftIndex > rightIndex ? 1 : 0;
        });
      }
    }]);

    return EventListener;
  }();

  function extendEvent(event) {
    if ("immediatePropagationStopped" in event) {
      return event;
    } else {
      var _stopImmediatePropagation = event.stopImmediatePropagation;
      return Object.assign(event, {
        immediatePropagationStopped: false,
        stopImmediatePropagation: function stopImmediatePropagation() {
          this.immediatePropagationStopped = true;

          _stopImmediatePropagation.call(this);
        }
      });
    }
  }

  var Dispatcher = /*#__PURE__*/function () {
    function Dispatcher(application) {
      _classCallCheck(this, Dispatcher);

      this.application = application;
      this.eventListenerMaps = new Map();
      this.started = false;
    }

    _createClass(Dispatcher, [{
      key: "start",
      value: function start() {
        if (!this.started) {
          this.started = true;
          this.eventListeners.forEach(function (eventListener) {
            return eventListener.connect();
          });
        }
      }
    }, {
      key: "stop",
      value: function stop() {
        if (this.started) {
          this.started = false;
          this.eventListeners.forEach(function (eventListener) {
            return eventListener.disconnect();
          });
        }
      }
    }, {
      key: "eventListeners",
      get: function get() {
        return Array.from(this.eventListenerMaps.values()).reduce(function (listeners, map) {
          return listeners.concat(Array.from(map.values()));
        }, []);
      }
    }, {
      key: "bindingConnected",
      value: function bindingConnected(binding) {
        this.fetchEventListenerForBinding(binding).bindingConnected(binding);
      }
    }, {
      key: "bindingDisconnected",
      value: function bindingDisconnected(binding) {
        var clearEventListeners = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        this.fetchEventListenerForBinding(binding).bindingDisconnected(binding);
        if (clearEventListeners) this.clearEventListenersForBinding(binding);
      }
    }, {
      key: "handleError",
      value: function handleError(error, message) {
        var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.application.handleError(error, "Error ".concat(message), detail);
      }
    }, {
      key: "clearEventListenersForBinding",
      value: function clearEventListenersForBinding(binding) {
        var eventListener = this.fetchEventListenerForBinding(binding);

        if (!eventListener.hasBindings()) {
          eventListener.disconnect();
          this.removeMappedEventListenerFor(binding);
        }
      }
    }, {
      key: "removeMappedEventListenerFor",
      value: function removeMappedEventListenerFor(binding) {
        var eventTarget = binding.eventTarget,
            eventName = binding.eventName,
            eventOptions = binding.eventOptions;
        var eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
        var cacheKey = this.cacheKey(eventName, eventOptions);
        eventListenerMap.delete(cacheKey);
        if (eventListenerMap.size == 0) this.eventListenerMaps.delete(eventTarget);
      }
    }, {
      key: "fetchEventListenerForBinding",
      value: function fetchEventListenerForBinding(binding) {
        var eventTarget = binding.eventTarget,
            eventName = binding.eventName,
            eventOptions = binding.eventOptions;
        return this.fetchEventListener(eventTarget, eventName, eventOptions);
      }
    }, {
      key: "fetchEventListener",
      value: function fetchEventListener(eventTarget, eventName, eventOptions) {
        var eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
        var cacheKey = this.cacheKey(eventName, eventOptions);
        var eventListener = eventListenerMap.get(cacheKey);

        if (!eventListener) {
          eventListener = this.createEventListener(eventTarget, eventName, eventOptions);
          eventListenerMap.set(cacheKey, eventListener);
        }

        return eventListener;
      }
    }, {
      key: "createEventListener",
      value: function createEventListener(eventTarget, eventName, eventOptions) {
        var eventListener = new EventListener(eventTarget, eventName, eventOptions);

        if (this.started) {
          eventListener.connect();
        }

        return eventListener;
      }
    }, {
      key: "fetchEventListenerMapForEventTarget",
      value: function fetchEventListenerMapForEventTarget(eventTarget) {
        var eventListenerMap = this.eventListenerMaps.get(eventTarget);

        if (!eventListenerMap) {
          eventListenerMap = new Map();
          this.eventListenerMaps.set(eventTarget, eventListenerMap);
        }

        return eventListenerMap;
      }
    }, {
      key: "cacheKey",
      value: function cacheKey(eventName, eventOptions) {
        var parts = [eventName];
        Object.keys(eventOptions).sort().forEach(function (key) {
          parts.push("".concat(eventOptions[key] ? "" : "!").concat(key));
        });
        return parts.join(":");
      }
    }]);

    return Dispatcher;
  }();

  var defaultActionDescriptorFilters = {
    stop: function stop(_ref) {
      var event = _ref.event,
          value = _ref.value;
      if (value) event.stopPropagation();
      return true;
    },
    prevent: function prevent(_ref2) {
      var event = _ref2.event,
          value = _ref2.value;
      if (value) event.preventDefault();
      return true;
    },
    self: function self(_ref3) {
      var event = _ref3.event,
          value = _ref3.value,
          element = _ref3.element;

      if (value) {
        return element === event.target;
      } else {
        return true;
      }
    }
  };
  var descriptorPattern = /^(?:(.+?)(?:\.(.+?))?(?:@(window|document))?->)?(.+?)(?:#([^:]+?))(?::(.+))?$/;

  function parseActionDescriptorString(descriptorString) {
    var source = descriptorString.trim();
    var matches = source.match(descriptorPattern) || [];
    var eventName = matches[1];
    var keyFilter = matches[2];

    if (keyFilter && !["keydown", "keyup", "keypress"].includes(eventName)) {
      eventName += ".".concat(keyFilter);
      keyFilter = "";
    }

    return {
      eventTarget: parseEventTarget(matches[3]),
      eventName: eventName,
      eventOptions: matches[6] ? parseEventOptions(matches[6]) : {},
      identifier: matches[4],
      methodName: matches[5],
      keyFilter: keyFilter
    };
  }

  function parseEventTarget(eventTargetName) {
    if (eventTargetName == "window") {
      return window;
    } else if (eventTargetName == "document") {
      return document;
    }
  }

  function parseEventOptions(eventOptions) {
    return eventOptions.split(":").reduce(function (options, token) {
      return Object.assign(options, _defineProperty({}, token.replace(/^!/, ""), !/^!/.test(token)));
    }, {});
  }

  function stringifyEventTarget(eventTarget) {
    if (eventTarget == window) {
      return "window";
    } else if (eventTarget == document) {
      return "document";
    }
  }

  function camelize(value) {
    return value.replace(/(?:[_-])([a-z0-9])/g, function (_, char) {
      return char.toUpperCase();
    });
  }

  function namespaceCamelize(value) {
    return camelize(value.replace(/--/g, "-").replace(/__/g, "_"));
  }

  function capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  function dasherize(value) {
    return value.replace(/([A-Z])/g, function (_, char) {
      return "-".concat(char.toLowerCase());
    });
  }

  function tokenize(value) {
    return value.match(/[^\s]+/g) || [];
  }

  var Action = /*#__PURE__*/function () {
    function Action(element, index, descriptor, schema) {
      _classCallCheck(this, Action);

      this.element = element;
      this.index = index;
      this.eventTarget = descriptor.eventTarget || element;
      this.eventName = descriptor.eventName || getDefaultEventNameForElement(element) || error("missing event name");
      this.eventOptions = descriptor.eventOptions || {};
      this.identifier = descriptor.identifier || error("missing identifier");
      this.methodName = descriptor.methodName || error("missing method name");
      this.keyFilter = descriptor.keyFilter || "";
      this.schema = schema;
    }

    _createClass(Action, [{
      key: "toString",
      value: function toString() {
        var eventFilter = this.keyFilter ? ".".concat(this.keyFilter) : "";
        var eventTarget = this.eventTargetName ? "@".concat(this.eventTargetName) : "";
        return "".concat(this.eventName).concat(eventFilter).concat(eventTarget, "->").concat(this.identifier, "#").concat(this.methodName);
      }
    }, {
      key: "isFilterTarget",
      value: function isFilterTarget(event) {
        if (!this.keyFilter) {
          return false;
        }

        var filteres = this.keyFilter.split("+");
        var modifiers = ["meta", "ctrl", "alt", "shift"];

        var _modifiers$map = modifiers.map(function (modifier) {
          return filteres.includes(modifier);
        }),
            _modifiers$map2 = _slicedToArray(_modifiers$map, 4),
            meta = _modifiers$map2[0],
            ctrl = _modifiers$map2[1],
            alt = _modifiers$map2[2],
            shift = _modifiers$map2[3];

        if (event.metaKey !== meta || event.ctrlKey !== ctrl || event.altKey !== alt || event.shiftKey !== shift) {
          return true;
        }

        var standardFilter = filteres.filter(function (key) {
          return !modifiers.includes(key);
        })[0];

        if (!standardFilter) {
          return false;
        }

        if (!Object.prototype.hasOwnProperty.call(this.keyMappings, standardFilter)) {
          error("contains unknown key filter: ".concat(this.keyFilter));
        }

        return this.keyMappings[standardFilter].toLowerCase() !== event.key.toLowerCase();
      }
    }, {
      key: "params",
      get: function get() {
        var params = {};
        var pattern = new RegExp("^data-".concat(this.identifier, "-(.+)-param$"), "i");

        for (var _i2 = 0, _Array$from = Array.from(this.element.attributes); _i2 < _Array$from.length; _i2++) {
          var _ref5 = _Array$from[_i2];
          var name = _ref5.name;
          var value = _ref5.value;
          var match = name.match(pattern);
          var key = match && match[1];

          if (key) {
            params[camelize(key)] = typecast(value);
          }
        }

        return params;
      }
    }, {
      key: "eventTargetName",
      get: function get() {
        return stringifyEventTarget(this.eventTarget);
      }
    }, {
      key: "keyMappings",
      get: function get() {
        return this.schema.keyMappings;
      }
    }], [{
      key: "forToken",
      value: function forToken(token, schema) {
        return new this(token.element, token.index, parseActionDescriptorString(token.content), schema);
      }
    }]);

    return Action;
  }();

  var defaultEventNames = {
    a: function a() {
      return "click";
    },
    button: function button() {
      return "click";
    },
    form: function form() {
      return "submit";
    },
    details: function details() {
      return "toggle";
    },
    input: function input(e) {
      return e.getAttribute("type") == "submit" ? "click" : "input";
    },
    select: function select() {
      return "change";
    },
    textarea: function textarea() {
      return "input";
    }
  };

  function getDefaultEventNameForElement(element) {
    var tagName = element.tagName.toLowerCase();

    if (tagName in defaultEventNames) {
      return defaultEventNames[tagName](element);
    }
  }

  function error(message) {
    throw new Error(message);
  }

  function typecast(value) {
    try {
      return JSON.parse(value);
    } catch (o_O) {
      return value;
    }
  }

  var Binding = /*#__PURE__*/function () {
    function Binding(context, action) {
      _classCallCheck(this, Binding);

      this.context = context;
      this.action = action;
    }

    _createClass(Binding, [{
      key: "index",
      get: function get() {
        return this.action.index;
      }
    }, {
      key: "eventTarget",
      get: function get() {
        return this.action.eventTarget;
      }
    }, {
      key: "eventOptions",
      get: function get() {
        return this.action.eventOptions;
      }
    }, {
      key: "identifier",
      get: function get() {
        return this.context.identifier;
      }
    }, {
      key: "handleEvent",
      value: function handleEvent(event) {
        if (this.willBeInvokedByEvent(event) && this.applyEventModifiers(event)) {
          this.invokeWithEvent(event);
        }
      }
    }, {
      key: "eventName",
      get: function get() {
        return this.action.eventName;
      }
    }, {
      key: "method",
      get: function get() {
        var method = this.controller[this.methodName];

        if (typeof method == "function") {
          return method;
        }

        throw new Error("Action \"".concat(this.action, "\" references undefined method \"").concat(this.methodName, "\""));
      }
    }, {
      key: "applyEventModifiers",
      value: function applyEventModifiers(event) {
        var element = this.action.element;
        var actionDescriptorFilters = this.context.application.actionDescriptorFilters;
        var passes = true;

        for (var _i3 = 0, _Object$entries = Object.entries(this.eventOptions); _i3 < _Object$entries.length; _i3++) {
          var _ref8 = _Object$entries[_i3];

          var _ref7 = _slicedToArray(_ref8, 2);

          var name = _ref7[0];
          var value = _ref7[1];

          if (name in actionDescriptorFilters) {
            var filter = actionDescriptorFilters[name];
            passes = passes && filter({
              name: name,
              value: value,
              event: event,
              element: element
            });
          } else {
            continue;
          }
        }

        return passes;
      }
    }, {
      key: "invokeWithEvent",
      value: function invokeWithEvent(event) {
        var target = event.target,
            currentTarget = event.currentTarget;

        try {
          var params = this.action.params;
          var actionEvent = Object.assign(event, {
            params: params
          });
          this.method.call(this.controller, actionEvent);
          this.context.logDebugActivity(this.methodName, {
            event: event,
            target: target,
            currentTarget: currentTarget,
            action: this.methodName
          });
        } catch (error) {
          var identifier = this.identifier,
              controller = this.controller,
              element = this.element,
              index = this.index;
          var detail = {
            identifier: identifier,
            controller: controller,
            element: element,
            index: index,
            event: event
          };
          this.context.handleError(error, "invoking action \"".concat(this.action, "\""), detail);
        }
      }
    }, {
      key: "willBeInvokedByEvent",
      value: function willBeInvokedByEvent(event) {
        var eventTarget = event.target;

        if (event instanceof KeyboardEvent && this.action.isFilterTarget(event)) {
          return false;
        }

        if (this.element === eventTarget) {
          return true;
        } else if (eventTarget instanceof Element && this.element.contains(eventTarget)) {
          return this.scope.containsElement(eventTarget);
        } else {
          return this.scope.containsElement(this.action.element);
        }
      }
    }, {
      key: "controller",
      get: function get() {
        return this.context.controller;
      }
    }, {
      key: "methodName",
      get: function get() {
        return this.action.methodName;
      }
    }, {
      key: "element",
      get: function get() {
        return this.scope.element;
      }
    }, {
      key: "scope",
      get: function get() {
        return this.context.scope;
      }
    }]);

    return Binding;
  }();

  var ElementObserver = /*#__PURE__*/function () {
    function ElementObserver(element, delegate) {
      var _this = this;

      _classCallCheck(this, ElementObserver);

      this.mutationObserverInit = {
        attributes: true,
        childList: true,
        subtree: true
      };
      this.element = element;
      this.started = false;
      this.delegate = delegate;
      this.elements = new Set();
      this.mutationObserver = new MutationObserver(function (mutations) {
        return _this.processMutations(mutations);
      });
    }

    _createClass(ElementObserver, [{
      key: "start",
      value: function start() {
        if (!this.started) {
          this.started = true;
          this.mutationObserver.observe(this.element, this.mutationObserverInit);
          this.refresh();
        }
      }
    }, {
      key: "pause",
      value: function pause(callback) {
        if (this.started) {
          this.mutationObserver.disconnect();
          this.started = false;
        }

        callback();

        if (!this.started) {
          this.mutationObserver.observe(this.element, this.mutationObserverInit);
          this.started = true;
        }
      }
    }, {
      key: "stop",
      value: function stop() {
        if (this.started) {
          this.mutationObserver.takeRecords();
          this.mutationObserver.disconnect();
          this.started = false;
        }
      }
    }, {
      key: "refresh",
      value: function refresh() {
        if (this.started) {
          var matches = new Set(this.matchElementsInTree());

          for (var _i4 = 0, _Array$from2 = Array.from(this.elements); _i4 < _Array$from2.length; _i4++) {
            var element = _Array$from2[_i4];

            if (!matches.has(element)) {
              this.removeElement(element);
            }
          }

          for (var _i5 = 0, _Array$from3 = Array.from(matches); _i5 < _Array$from3.length; _i5++) {
            var _element = _Array$from3[_i5];
            this.addElement(_element);
          }
        }
      }
    }, {
      key: "processMutations",
      value: function processMutations(mutations) {
        if (this.started) {
          var _iterator2 = _createForOfIteratorHelper(mutations),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var mutation = _step2.value;
              this.processMutation(mutation);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }
    }, {
      key: "processMutation",
      value: function processMutation(mutation) {
        if (mutation.type == "attributes") {
          this.processAttributeChange(mutation.target, mutation.attributeName);
        } else if (mutation.type == "childList") {
          this.processRemovedNodes(mutation.removedNodes);
          this.processAddedNodes(mutation.addedNodes);
        }
      }
    }, {
      key: "processAttributeChange",
      value: function processAttributeChange(node, attributeName) {
        var element = node;

        if (this.elements.has(element)) {
          if (this.delegate.elementAttributeChanged && this.matchElement(element)) {
            this.delegate.elementAttributeChanged(element, attributeName);
          } else {
            this.removeElement(element);
          }
        } else if (this.matchElement(element)) {
          this.addElement(element);
        }
      }
    }, {
      key: "processRemovedNodes",
      value: function processRemovedNodes(nodes) {
        for (var _i6 = 0, _Array$from4 = Array.from(nodes); _i6 < _Array$from4.length; _i6++) {
          var node = _Array$from4[_i6];
          var element = this.elementFromNode(node);

          if (element) {
            this.processTree(element, this.removeElement);
          }
        }
      }
    }, {
      key: "processAddedNodes",
      value: function processAddedNodes(nodes) {
        for (var _i7 = 0, _Array$from5 = Array.from(nodes); _i7 < _Array$from5.length; _i7++) {
          var node = _Array$from5[_i7];
          var element = this.elementFromNode(node);

          if (element && this.elementIsActive(element)) {
            this.processTree(element, this.addElement);
          }
        }
      }
    }, {
      key: "matchElement",
      value: function matchElement(element) {
        return this.delegate.matchElement(element);
      }
    }, {
      key: "matchElementsInTree",
      value: function matchElementsInTree() {
        var tree = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.element;
        return this.delegate.matchElementsInTree(tree);
      }
    }, {
      key: "processTree",
      value: function processTree(tree, processor) {
        var _iterator3 = _createForOfIteratorHelper(this.matchElementsInTree(tree)),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var element = _step3.value;
            processor.call(this, element);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }, {
      key: "elementFromNode",
      value: function elementFromNode(node) {
        if (node.nodeType == Node.ELEMENT_NODE) {
          return node;
        }
      }
    }, {
      key: "elementIsActive",
      value: function elementIsActive(element) {
        if (element.isConnected != this.element.isConnected) {
          return false;
        } else {
          return this.element.contains(element);
        }
      }
    }, {
      key: "addElement",
      value: function addElement(element) {
        if (!this.elements.has(element)) {
          if (this.elementIsActive(element)) {
            this.elements.add(element);

            if (this.delegate.elementMatched) {
              this.delegate.elementMatched(element);
            }
          }
        }
      }
    }, {
      key: "removeElement",
      value: function removeElement(element) {
        if (this.elements.has(element)) {
          this.elements.delete(element);

          if (this.delegate.elementUnmatched) {
            this.delegate.elementUnmatched(element);
          }
        }
      }
    }]);

    return ElementObserver;
  }();

  var AttributeObserver = /*#__PURE__*/function () {
    function AttributeObserver(element, attributeName, delegate) {
      _classCallCheck(this, AttributeObserver);

      this.attributeName = attributeName;
      this.delegate = delegate;
      this.elementObserver = new ElementObserver(element, this);
    }

    _createClass(AttributeObserver, [{
      key: "element",
      get: function get() {
        return this.elementObserver.element;
      }
    }, {
      key: "selector",
      get: function get() {
        return "[".concat(this.attributeName, "]");
      }
    }, {
      key: "start",
      value: function start() {
        this.elementObserver.start();
      }
    }, {
      key: "pause",
      value: function pause(callback) {
        this.elementObserver.pause(callback);
      }
    }, {
      key: "stop",
      value: function stop() {
        this.elementObserver.stop();
      }
    }, {
      key: "refresh",
      value: function refresh() {
        this.elementObserver.refresh();
      }
    }, {
      key: "started",
      get: function get() {
        return this.elementObserver.started;
      }
    }, {
      key: "matchElement",
      value: function matchElement(element) {
        return element.hasAttribute(this.attributeName);
      }
    }, {
      key: "matchElementsInTree",
      value: function matchElementsInTree(tree) {
        var match = this.matchElement(tree) ? [tree] : [];
        var matches = Array.from(tree.querySelectorAll(this.selector));
        return match.concat(matches);
      }
    }, {
      key: "elementMatched",
      value: function elementMatched(element) {
        if (this.delegate.elementMatchedAttribute) {
          this.delegate.elementMatchedAttribute(element, this.attributeName);
        }
      }
    }, {
      key: "elementUnmatched",
      value: function elementUnmatched(element) {
        if (this.delegate.elementUnmatchedAttribute) {
          this.delegate.elementUnmatchedAttribute(element, this.attributeName);
        }
      }
    }, {
      key: "elementAttributeChanged",
      value: function elementAttributeChanged(element, attributeName) {
        if (this.delegate.elementAttributeValueChanged && this.attributeName == attributeName) {
          this.delegate.elementAttributeValueChanged(element, attributeName);
        }
      }
    }]);

    return AttributeObserver;
  }();

  function _add(map, key, value) {
    fetch(map, key).add(value);
  }

  function del(map, key, value) {
    fetch(map, key).delete(value);
    prune(map, key);
  }

  function fetch(map, key) {
    var values = map.get(key);

    if (!values) {
      values = new Set();
      map.set(key, values);
    }

    return values;
  }

  function prune(map, key) {
    var values = map.get(key);

    if (values != null && values.size == 0) {
      map.delete(key);
    }
  }

  var Multimap = /*#__PURE__*/function () {
    function Multimap() {
      _classCallCheck(this, Multimap);

      this.valuesByKey = new Map();
    }

    _createClass(Multimap, [{
      key: "keys",
      get: function get() {
        return Array.from(this.valuesByKey.keys());
      }
    }, {
      key: "values",
      get: function get() {
        var sets = Array.from(this.valuesByKey.values());
        return sets.reduce(function (values, set) {
          return values.concat(Array.from(set));
        }, []);
      }
    }, {
      key: "size",
      get: function get() {
        var sets = Array.from(this.valuesByKey.values());
        return sets.reduce(function (size, set) {
          return size + set.size;
        }, 0);
      }
    }, {
      key: "add",
      value: function add(key, value) {
        _add(this.valuesByKey, key, value);
      }
    }, {
      key: "delete",
      value: function _delete(key, value) {
        del(this.valuesByKey, key, value);
      }
    }, {
      key: "has",
      value: function has(key, value) {
        var values = this.valuesByKey.get(key);
        return values != null && values.has(value);
      }
    }, {
      key: "hasKey",
      value: function hasKey(key) {
        return this.valuesByKey.has(key);
      }
    }, {
      key: "hasValue",
      value: function hasValue(value) {
        var sets = Array.from(this.valuesByKey.values());
        return sets.some(function (set) {
          return set.has(value);
        });
      }
    }, {
      key: "getValuesForKey",
      value: function getValuesForKey(key) {
        var values = this.valuesByKey.get(key);
        return values ? Array.from(values) : [];
      }
    }, {
      key: "getKeysForValue",
      value: function getKeysForValue(value) {
        return Array.from(this.valuesByKey).filter(function (_ref9) {
          var _ref10 = _slicedToArray(_ref9, 2),
              _key = _ref10[0],
              values = _ref10[1];

          return values.has(value);
        }).map(function (_ref11) {
          var _ref12 = _slicedToArray(_ref11, 2),
              key = _ref12[0],
              _values = _ref12[1];

          return key;
        });
      }
    }]);

    return Multimap;
  }();

  var IndexedMultimap = /*#__PURE__*/function (_Multimap) {
    _inherits(IndexedMultimap, _Multimap);

    var _super = _createSuper(IndexedMultimap);

    function IndexedMultimap() {
      var _this2;

      _classCallCheck(this, IndexedMultimap);

      _this2 = _super.call(this);
      _this2.keysByValue = new Map();
      return _this2;
    }

    _createClass(IndexedMultimap, [{
      key: "values",
      get: function get() {
        return Array.from(this.keysByValue.keys());
      }
    }, {
      key: "add",
      value: function add(key, value) {
        _get(_getPrototypeOf(IndexedMultimap.prototype), "add", this).call(this, key, value);

        _add(this.keysByValue, value, key);
      }
    }, {
      key: "delete",
      value: function _delete(key, value) {
        _get(_getPrototypeOf(IndexedMultimap.prototype), "delete", this).call(this, key, value);

        del(this.keysByValue, value, key);
      }
    }, {
      key: "hasValue",
      value: function hasValue(value) {
        return this.keysByValue.has(value);
      }
    }, {
      key: "getKeysForValue",
      value: function getKeysForValue(value) {
        var set = this.keysByValue.get(value);
        return set ? Array.from(set) : [];
      }
    }]);

    return IndexedMultimap;
  }(Multimap);

  var SelectorObserver = /*#__PURE__*/function () {
    function SelectorObserver(element, selector, delegate) {
      var details = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      _classCallCheck(this, SelectorObserver);

      this.selector = selector;
      this.details = details;
      this.elementObserver = new ElementObserver(element, this);
      this.delegate = delegate;
      this.matchesByElement = new Multimap();
    }

    _createClass(SelectorObserver, [{
      key: "started",
      get: function get() {
        return this.elementObserver.started;
      }
    }, {
      key: "start",
      value: function start() {
        this.elementObserver.start();
      }
    }, {
      key: "pause",
      value: function pause(callback) {
        this.elementObserver.pause(callback);
      }
    }, {
      key: "stop",
      value: function stop() {
        this.elementObserver.stop();
      }
    }, {
      key: "refresh",
      value: function refresh() {
        this.elementObserver.refresh();
      }
    }, {
      key: "element",
      get: function get() {
        return this.elementObserver.element;
      }
    }, {
      key: "matchElement",
      value: function matchElement(element) {
        var matches = element.matches(this.selector);

        if (this.delegate.selectorMatchElement) {
          return matches && this.delegate.selectorMatchElement(element, this.details);
        }

        return matches;
      }
    }, {
      key: "matchElementsInTree",
      value: function matchElementsInTree(tree) {
        var _this3 = this;

        var match = this.matchElement(tree) ? [tree] : [];
        var matches = Array.from(tree.querySelectorAll(this.selector)).filter(function (match) {
          return _this3.matchElement(match);
        });
        return match.concat(matches);
      }
    }, {
      key: "elementMatched",
      value: function elementMatched(element) {
        this.selectorMatched(element);
      }
    }, {
      key: "elementUnmatched",
      value: function elementUnmatched(element) {
        this.selectorUnmatched(element);
      }
    }, {
      key: "elementAttributeChanged",
      value: function elementAttributeChanged(element, _attributeName) {
        var matches = this.matchElement(element);
        var matchedBefore = this.matchesByElement.has(this.selector, element);

        if (!matches && matchedBefore) {
          this.selectorUnmatched(element);
        }
      }
    }, {
      key: "selectorMatched",
      value: function selectorMatched(element) {
        if (this.delegate.selectorMatched) {
          this.delegate.selectorMatched(element, this.selector, this.details);
          this.matchesByElement.add(this.selector, element);
        }
      }
    }, {
      key: "selectorUnmatched",
      value: function selectorUnmatched(element) {
        this.delegate.selectorUnmatched(element, this.selector, this.details);
        this.matchesByElement.delete(this.selector, element);
      }
    }]);

    return SelectorObserver;
  }();

  var StringMapObserver = /*#__PURE__*/function () {
    function StringMapObserver(element, delegate) {
      var _this4 = this;

      _classCallCheck(this, StringMapObserver);

      this.element = element;
      this.delegate = delegate;
      this.started = false;
      this.stringMap = new Map();
      this.mutationObserver = new MutationObserver(function (mutations) {
        return _this4.processMutations(mutations);
      });
    }

    _createClass(StringMapObserver, [{
      key: "start",
      value: function start() {
        if (!this.started) {
          this.started = true;
          this.mutationObserver.observe(this.element, {
            attributes: true,
            attributeOldValue: true
          });
          this.refresh();
        }
      }
    }, {
      key: "stop",
      value: function stop() {
        if (this.started) {
          this.mutationObserver.takeRecords();
          this.mutationObserver.disconnect();
          this.started = false;
        }
      }
    }, {
      key: "refresh",
      value: function refresh() {
        if (this.started) {
          var _iterator4 = _createForOfIteratorHelper(this.knownAttributeNames),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var attributeName = _step4.value;
              this.refreshAttribute(attributeName, null);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      }
    }, {
      key: "processMutations",
      value: function processMutations(mutations) {
        if (this.started) {
          var _iterator5 = _createForOfIteratorHelper(mutations),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var mutation = _step5.value;
              this.processMutation(mutation);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      }
    }, {
      key: "processMutation",
      value: function processMutation(mutation) {
        var attributeName = mutation.attributeName;

        if (attributeName) {
          this.refreshAttribute(attributeName, mutation.oldValue);
        }
      }
    }, {
      key: "refreshAttribute",
      value: function refreshAttribute(attributeName, oldValue) {
        var key = this.delegate.getStringMapKeyForAttribute(attributeName);

        if (key != null) {
          if (!this.stringMap.has(attributeName)) {
            this.stringMapKeyAdded(key, attributeName);
          }

          var value = this.element.getAttribute(attributeName);

          if (this.stringMap.get(attributeName) != value) {
            this.stringMapValueChanged(value, key, oldValue);
          }

          if (value == null) {
            var _oldValue = this.stringMap.get(attributeName);

            this.stringMap.delete(attributeName);
            if (_oldValue) this.stringMapKeyRemoved(key, attributeName, _oldValue);
          } else {
            this.stringMap.set(attributeName, value);
          }
        }
      }
    }, {
      key: "stringMapKeyAdded",
      value: function stringMapKeyAdded(key, attributeName) {
        if (this.delegate.stringMapKeyAdded) {
          this.delegate.stringMapKeyAdded(key, attributeName);
        }
      }
    }, {
      key: "stringMapValueChanged",
      value: function stringMapValueChanged(value, key, oldValue) {
        if (this.delegate.stringMapValueChanged) {
          this.delegate.stringMapValueChanged(value, key, oldValue);
        }
      }
    }, {
      key: "stringMapKeyRemoved",
      value: function stringMapKeyRemoved(key, attributeName, oldValue) {
        if (this.delegate.stringMapKeyRemoved) {
          this.delegate.stringMapKeyRemoved(key, attributeName, oldValue);
        }
      }
    }, {
      key: "knownAttributeNames",
      get: function get() {
        return Array.from(new Set(this.currentAttributeNames.concat(this.recordedAttributeNames)));
      }
    }, {
      key: "currentAttributeNames",
      get: function get() {
        return Array.from(this.element.attributes).map(function (attribute) {
          return attribute.name;
        });
      }
    }, {
      key: "recordedAttributeNames",
      get: function get() {
        return Array.from(this.stringMap.keys());
      }
    }]);

    return StringMapObserver;
  }();

  var TokenListObserver = /*#__PURE__*/function () {
    function TokenListObserver(element, attributeName, delegate) {
      _classCallCheck(this, TokenListObserver);

      this.attributeObserver = new AttributeObserver(element, attributeName, this);
      this.delegate = delegate;
      this.tokensByElement = new Multimap();
    }

    _createClass(TokenListObserver, [{
      key: "started",
      get: function get() {
        return this.attributeObserver.started;
      }
    }, {
      key: "start",
      value: function start() {
        this.attributeObserver.start();
      }
    }, {
      key: "pause",
      value: function pause(callback) {
        this.attributeObserver.pause(callback);
      }
    }, {
      key: "stop",
      value: function stop() {
        this.attributeObserver.stop();
      }
    }, {
      key: "refresh",
      value: function refresh() {
        this.attributeObserver.refresh();
      }
    }, {
      key: "element",
      get: function get() {
        return this.attributeObserver.element;
      }
    }, {
      key: "attributeName",
      get: function get() {
        return this.attributeObserver.attributeName;
      }
    }, {
      key: "elementMatchedAttribute",
      value: function elementMatchedAttribute(element) {
        this.tokensMatched(this.readTokensForElement(element));
      }
    }, {
      key: "elementAttributeValueChanged",
      value: function elementAttributeValueChanged(element) {
        var _this$refreshTokensFo = this.refreshTokensForElement(element),
            _this$refreshTokensFo2 = _slicedToArray(_this$refreshTokensFo, 2),
            unmatchedTokens = _this$refreshTokensFo2[0],
            matchedTokens = _this$refreshTokensFo2[1];

        this.tokensUnmatched(unmatchedTokens);
        this.tokensMatched(matchedTokens);
      }
    }, {
      key: "elementUnmatchedAttribute",
      value: function elementUnmatchedAttribute(element) {
        this.tokensUnmatched(this.tokensByElement.getValuesForKey(element));
      }
    }, {
      key: "tokensMatched",
      value: function tokensMatched(tokens) {
        var _this5 = this;

        tokens.forEach(function (token) {
          return _this5.tokenMatched(token);
        });
      }
    }, {
      key: "tokensUnmatched",
      value: function tokensUnmatched(tokens) {
        var _this6 = this;

        tokens.forEach(function (token) {
          return _this6.tokenUnmatched(token);
        });
      }
    }, {
      key: "tokenMatched",
      value: function tokenMatched(token) {
        this.delegate.tokenMatched(token);
        this.tokensByElement.add(token.element, token);
      }
    }, {
      key: "tokenUnmatched",
      value: function tokenUnmatched(token) {
        this.delegate.tokenUnmatched(token);
        this.tokensByElement.delete(token.element, token);
      }
    }, {
      key: "refreshTokensForElement",
      value: function refreshTokensForElement(element) {
        var previousTokens = this.tokensByElement.getValuesForKey(element);
        var currentTokens = this.readTokensForElement(element);
        var firstDifferingIndex = zip(previousTokens, currentTokens).findIndex(function (_ref13) {
          var _ref14 = _slicedToArray(_ref13, 2),
              previousToken = _ref14[0],
              currentToken = _ref14[1];

          return !tokensAreEqual(previousToken, currentToken);
        });

        if (firstDifferingIndex == -1) {
          return [[], []];
        } else {
          return [previousTokens.slice(firstDifferingIndex), currentTokens.slice(firstDifferingIndex)];
        }
      }
    }, {
      key: "readTokensForElement",
      value: function readTokensForElement(element) {
        var attributeName = this.attributeName;
        var tokenString = element.getAttribute(attributeName) || "";
        return parseTokenString(tokenString, element, attributeName);
      }
    }]);

    return TokenListObserver;
  }();

  function parseTokenString(tokenString, element, attributeName) {
    return tokenString.trim().split(/\s+/).filter(function (content) {
      return content.length;
    }).map(function (content, index) {
      return {
        element: element,
        attributeName: attributeName,
        content: content,
        index: index
      };
    });
  }

  function zip(left, right) {
    var length = Math.max(left.length, right.length);
    return Array.from({
      length: length
    }, function (_, index) {
      return [left[index], right[index]];
    });
  }

  function tokensAreEqual(left, right) {
    return left && right && left.index == right.index && left.content == right.content;
  }

  var ValueListObserver = /*#__PURE__*/function () {
    function ValueListObserver(element, attributeName, delegate) {
      _classCallCheck(this, ValueListObserver);

      this.tokenListObserver = new TokenListObserver(element, attributeName, this);
      this.delegate = delegate;
      this.parseResultsByToken = new WeakMap();
      this.valuesByTokenByElement = new WeakMap();
    }

    _createClass(ValueListObserver, [{
      key: "started",
      get: function get() {
        return this.tokenListObserver.started;
      }
    }, {
      key: "start",
      value: function start() {
        this.tokenListObserver.start();
      }
    }, {
      key: "stop",
      value: function stop() {
        this.tokenListObserver.stop();
      }
    }, {
      key: "refresh",
      value: function refresh() {
        this.tokenListObserver.refresh();
      }
    }, {
      key: "element",
      get: function get() {
        return this.tokenListObserver.element;
      }
    }, {
      key: "attributeName",
      get: function get() {
        return this.tokenListObserver.attributeName;
      }
    }, {
      key: "tokenMatched",
      value: function tokenMatched(token) {
        var element = token.element;

        var _this$fetchParseResul = this.fetchParseResultForToken(token),
            value = _this$fetchParseResul.value;

        if (value) {
          this.fetchValuesByTokenForElement(element).set(token, value);
          this.delegate.elementMatchedValue(element, value);
        }
      }
    }, {
      key: "tokenUnmatched",
      value: function tokenUnmatched(token) {
        var element = token.element;

        var _this$fetchParseResul2 = this.fetchParseResultForToken(token),
            value = _this$fetchParseResul2.value;

        if (value) {
          this.fetchValuesByTokenForElement(element).delete(token);
          this.delegate.elementUnmatchedValue(element, value);
        }
      }
    }, {
      key: "fetchParseResultForToken",
      value: function fetchParseResultForToken(token) {
        var parseResult = this.parseResultsByToken.get(token);

        if (!parseResult) {
          parseResult = this.parseToken(token);
          this.parseResultsByToken.set(token, parseResult);
        }

        return parseResult;
      }
    }, {
      key: "fetchValuesByTokenForElement",
      value: function fetchValuesByTokenForElement(element) {
        var valuesByToken = this.valuesByTokenByElement.get(element);

        if (!valuesByToken) {
          valuesByToken = new Map();
          this.valuesByTokenByElement.set(element, valuesByToken);
        }

        return valuesByToken;
      }
    }, {
      key: "parseToken",
      value: function parseToken(token) {
        try {
          var value = this.delegate.parseValueForToken(token);
          return {
            value: value
          };
        } catch (error) {
          return {
            error: error
          };
        }
      }
    }]);

    return ValueListObserver;
  }();

  var BindingObserver = /*#__PURE__*/function () {
    function BindingObserver(context, delegate) {
      _classCallCheck(this, BindingObserver);

      this.context = context;
      this.delegate = delegate;
      this.bindingsByAction = new Map();
    }

    _createClass(BindingObserver, [{
      key: "start",
      value: function start() {
        if (!this.valueListObserver) {
          this.valueListObserver = new ValueListObserver(this.element, this.actionAttribute, this);
          this.valueListObserver.start();
        }
      }
    }, {
      key: "stop",
      value: function stop() {
        if (this.valueListObserver) {
          this.valueListObserver.stop();
          delete this.valueListObserver;
          this.disconnectAllActions();
        }
      }
    }, {
      key: "element",
      get: function get() {
        return this.context.element;
      }
    }, {
      key: "identifier",
      get: function get() {
        return this.context.identifier;
      }
    }, {
      key: "actionAttribute",
      get: function get() {
        return this.schema.actionAttribute;
      }
    }, {
      key: "schema",
      get: function get() {
        return this.context.schema;
      }
    }, {
      key: "bindings",
      get: function get() {
        return Array.from(this.bindingsByAction.values());
      }
    }, {
      key: "connectAction",
      value: function connectAction(action) {
        var binding = new Binding(this.context, action);
        this.bindingsByAction.set(action, binding);
        this.delegate.bindingConnected(binding);
      }
    }, {
      key: "disconnectAction",
      value: function disconnectAction(action) {
        var binding = this.bindingsByAction.get(action);

        if (binding) {
          this.bindingsByAction.delete(action);
          this.delegate.bindingDisconnected(binding);
        }
      }
    }, {
      key: "disconnectAllActions",
      value: function disconnectAllActions() {
        var _this7 = this;

        this.bindings.forEach(function (binding) {
          return _this7.delegate.bindingDisconnected(binding, true);
        });
        this.bindingsByAction.clear();
      }
    }, {
      key: "parseValueForToken",
      value: function parseValueForToken(token) {
        var action = Action.forToken(token, this.schema);

        if (action.identifier == this.identifier) {
          return action;
        }
      }
    }, {
      key: "elementMatchedValue",
      value: function elementMatchedValue(element, action) {
        this.connectAction(action);
      }
    }, {
      key: "elementUnmatchedValue",
      value: function elementUnmatchedValue(element, action) {
        this.disconnectAction(action);
      }
    }]);

    return BindingObserver;
  }();

  var ValueObserver = /*#__PURE__*/function () {
    function ValueObserver(context, receiver) {
      _classCallCheck(this, ValueObserver);

      this.context = context;
      this.receiver = receiver;
      this.stringMapObserver = new StringMapObserver(this.element, this);
      this.valueDescriptorMap = this.controller.valueDescriptorMap;
    }

    _createClass(ValueObserver, [{
      key: "start",
      value: function start() {
        this.stringMapObserver.start();
        this.invokeChangedCallbacksForDefaultValues();
      }
    }, {
      key: "stop",
      value: function stop() {
        this.stringMapObserver.stop();
      }
    }, {
      key: "element",
      get: function get() {
        return this.context.element;
      }
    }, {
      key: "controller",
      get: function get() {
        return this.context.controller;
      }
    }, {
      key: "getStringMapKeyForAttribute",
      value: function getStringMapKeyForAttribute(attributeName) {
        if (attributeName in this.valueDescriptorMap) {
          return this.valueDescriptorMap[attributeName].name;
        }
      }
    }, {
      key: "stringMapKeyAdded",
      value: function stringMapKeyAdded(key, attributeName) {
        var descriptor = this.valueDescriptorMap[attributeName];

        if (!this.hasValue(key)) {
          this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), descriptor.writer(descriptor.defaultValue));
        }
      }
    }, {
      key: "stringMapValueChanged",
      value: function stringMapValueChanged(value, name, oldValue) {
        var descriptor = this.valueDescriptorNameMap[name];
        if (value === null) return;

        if (oldValue === null) {
          oldValue = descriptor.writer(descriptor.defaultValue);
        }

        this.invokeChangedCallback(name, value, oldValue);
      }
    }, {
      key: "stringMapKeyRemoved",
      value: function stringMapKeyRemoved(key, attributeName, oldValue) {
        var descriptor = this.valueDescriptorNameMap[key];

        if (this.hasValue(key)) {
          this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), oldValue);
        } else {
          this.invokeChangedCallback(key, descriptor.writer(descriptor.defaultValue), oldValue);
        }
      }
    }, {
      key: "invokeChangedCallbacksForDefaultValues",
      value: function invokeChangedCallbacksForDefaultValues() {
        var _iterator6 = _createForOfIteratorHelper(this.valueDescriptors),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _ref16 = _step6.value;
            var key = _ref16.key;
            var name = _ref16.name;
            var defaultValue = _ref16.defaultValue;
            var writer = _ref16.writer;

            if (defaultValue != undefined && !this.controller.data.has(key)) {
              this.invokeChangedCallback(name, writer(defaultValue), undefined);
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }, {
      key: "invokeChangedCallback",
      value: function invokeChangedCallback(name, rawValue, rawOldValue) {
        var changedMethodName = "".concat(name, "Changed");
        var changedMethod = this.receiver[changedMethodName];

        if (typeof changedMethod == "function") {
          var descriptor = this.valueDescriptorNameMap[name];

          try {
            var value = descriptor.reader(rawValue);
            var oldValue = rawOldValue;

            if (rawOldValue) {
              oldValue = descriptor.reader(rawOldValue);
            }

            changedMethod.call(this.receiver, value, oldValue);
          } catch (error) {
            if (error instanceof TypeError) {
              error.message = "Stimulus Value \"".concat(this.context.identifier, ".").concat(descriptor.name, "\" - ").concat(error.message);
            }

            throw error;
          }
        }
      }
    }, {
      key: "valueDescriptors",
      get: function get() {
        var valueDescriptorMap = this.valueDescriptorMap;
        return Object.keys(valueDescriptorMap).map(function (key) {
          return valueDescriptorMap[key];
        });
      }
    }, {
      key: "valueDescriptorNameMap",
      get: function get() {
        var _this8 = this;

        var descriptors = {};
        Object.keys(this.valueDescriptorMap).forEach(function (key) {
          var descriptor = _this8.valueDescriptorMap[key];
          descriptors[descriptor.name] = descriptor;
        });
        return descriptors;
      }
    }, {
      key: "hasValue",
      value: function hasValue(attributeName) {
        var descriptor = this.valueDescriptorNameMap[attributeName];
        var hasMethodName = "has".concat(capitalize(descriptor.name));
        return this.receiver[hasMethodName];
      }
    }]);

    return ValueObserver;
  }();

  var TargetObserver = /*#__PURE__*/function () {
    function TargetObserver(context, delegate) {
      _classCallCheck(this, TargetObserver);

      this.context = context;
      this.delegate = delegate;
      this.targetsByName = new Multimap();
    }

    _createClass(TargetObserver, [{
      key: "start",
      value: function start() {
        if (!this.tokenListObserver) {
          this.tokenListObserver = new TokenListObserver(this.element, this.attributeName, this);
          this.tokenListObserver.start();
        }
      }
    }, {
      key: "stop",
      value: function stop() {
        if (this.tokenListObserver) {
          this.disconnectAllTargets();
          this.tokenListObserver.stop();
          delete this.tokenListObserver;
        }
      }
    }, {
      key: "tokenMatched",
      value: function tokenMatched(_ref17) {
        var element = _ref17.element,
            name = _ref17.content;

        if (this.scope.containsElement(element)) {
          this.connectTarget(element, name);
        }
      }
    }, {
      key: "tokenUnmatched",
      value: function tokenUnmatched(_ref18) {
        var element = _ref18.element,
            name = _ref18.content;
        this.disconnectTarget(element, name);
      }
    }, {
      key: "connectTarget",
      value: function connectTarget(element, name) {
        var _this9 = this;

        var _a;

        if (!this.targetsByName.has(name, element)) {
          this.targetsByName.add(name, element);
          (_a = this.tokenListObserver) === null || _a === void 0 ? void 0 : _a.pause(function () {
            return _this9.delegate.targetConnected(element, name);
          });
        }
      }
    }, {
      key: "disconnectTarget",
      value: function disconnectTarget(element, name) {
        var _this10 = this;

        var _a;

        if (this.targetsByName.has(name, element)) {
          this.targetsByName.delete(name, element);
          (_a = this.tokenListObserver) === null || _a === void 0 ? void 0 : _a.pause(function () {
            return _this10.delegate.targetDisconnected(element, name);
          });
        }
      }
    }, {
      key: "disconnectAllTargets",
      value: function disconnectAllTargets() {
        var _iterator7 = _createForOfIteratorHelper(this.targetsByName.keys),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var name = _step7.value;

            var _iterator8 = _createForOfIteratorHelper(this.targetsByName.getValuesForKey(name)),
                _step8;

            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var element = _step8.value;
                this.disconnectTarget(element, name);
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }
    }, {
      key: "attributeName",
      get: function get() {
        return "data-".concat(this.context.identifier, "-target");
      }
    }, {
      key: "element",
      get: function get() {
        return this.context.element;
      }
    }, {
      key: "scope",
      get: function get() {
        return this.context.scope;
      }
    }]);

    return TargetObserver;
  }();

  function readInheritableStaticArrayValues(constructor, propertyName) {
    var ancestors = getAncestorsForConstructor(constructor);
    return Array.from(ancestors.reduce(function (values, constructor) {
      getOwnStaticArrayValues(constructor, propertyName).forEach(function (name) {
        return values.add(name);
      });
      return values;
    }, new Set()));
  }

  function readInheritableStaticObjectPairs(constructor, propertyName) {
    var ancestors = getAncestorsForConstructor(constructor);
    return ancestors.reduce(function (pairs, constructor) {
      pairs.push.apply(pairs, _toConsumableArray(getOwnStaticObjectPairs(constructor, propertyName)));
      return pairs;
    }, []);
  }

  function getAncestorsForConstructor(constructor) {
    var ancestors = [];

    while (constructor) {
      ancestors.push(constructor);
      constructor = Object.getPrototypeOf(constructor);
    }

    return ancestors.reverse();
  }

  function getOwnStaticArrayValues(constructor, propertyName) {
    var definition = constructor[propertyName];
    return Array.isArray(definition) ? definition : [];
  }

  function getOwnStaticObjectPairs(constructor, propertyName) {
    var definition = constructor[propertyName];
    return definition ? Object.keys(definition).map(function (key) {
      return [key, definition[key]];
    }) : [];
  }

  var OutletObserver = /*#__PURE__*/function () {
    function OutletObserver(context, delegate) {
      _classCallCheck(this, OutletObserver);

      this.context = context;
      this.delegate = delegate;
      this.outletsByName = new Multimap();
      this.outletElementsByName = new Multimap();
      this.selectorObserverMap = new Map();
    }

    _createClass(OutletObserver, [{
      key: "start",
      value: function start() {
        var _this11 = this;

        if (this.selectorObserverMap.size === 0) {
          this.outletDefinitions.forEach(function (outletName) {
            var selector = _this11.selector(outletName);

            var details = {
              outletName: outletName
            };

            if (selector) {
              _this11.selectorObserverMap.set(outletName, new SelectorObserver(document.body, selector, _this11, details));
            }
          });
          this.selectorObserverMap.forEach(function (observer) {
            return observer.start();
          });
        }

        this.dependentContexts.forEach(function (context) {
          return context.refresh();
        });
      }
    }, {
      key: "stop",
      value: function stop() {
        if (this.selectorObserverMap.size > 0) {
          this.disconnectAllOutlets();
          this.selectorObserverMap.forEach(function (observer) {
            return observer.stop();
          });
          this.selectorObserverMap.clear();
        }
      }
    }, {
      key: "refresh",
      value: function refresh() {
        this.selectorObserverMap.forEach(function (observer) {
          return observer.refresh();
        });
      }
    }, {
      key: "selectorMatched",
      value: function selectorMatched(element, _selector, _ref19) {
        var outletName = _ref19.outletName;
        var outlet = this.getOutlet(element, outletName);

        if (outlet) {
          this.connectOutlet(outlet, element, outletName);
        }
      }
    }, {
      key: "selectorUnmatched",
      value: function selectorUnmatched(element, _selector, _ref20) {
        var outletName = _ref20.outletName;
        var outlet = this.getOutletFromMap(element, outletName);

        if (outlet) {
          this.disconnectOutlet(outlet, element, outletName);
        }
      }
    }, {
      key: "selectorMatchElement",
      value: function selectorMatchElement(element, _ref21) {
        var outletName = _ref21.outletName;
        return this.hasOutlet(element, outletName) && element.matches("[".concat(this.context.application.schema.controllerAttribute, "~=").concat(outletName, "]"));
      }
    }, {
      key: "connectOutlet",
      value: function connectOutlet(outlet, element, outletName) {
        var _this12 = this;

        var _a;

        if (!this.outletElementsByName.has(outletName, element)) {
          this.outletsByName.add(outletName, outlet);
          this.outletElementsByName.add(outletName, element);
          (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 ? void 0 : _a.pause(function () {
            return _this12.delegate.outletConnected(outlet, element, outletName);
          });
        }
      }
    }, {
      key: "disconnectOutlet",
      value: function disconnectOutlet(outlet, element, outletName) {
        var _this13 = this;

        var _a;

        if (this.outletElementsByName.has(outletName, element)) {
          this.outletsByName.delete(outletName, outlet);
          this.outletElementsByName.delete(outletName, element);
          (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 ? void 0 : _a.pause(function () {
            return _this13.delegate.outletDisconnected(outlet, element, outletName);
          });
        }
      }
    }, {
      key: "disconnectAllOutlets",
      value: function disconnectAllOutlets() {
        var _iterator9 = _createForOfIteratorHelper(this.outletElementsByName.keys),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var outletName = _step9.value;

            var _iterator10 = _createForOfIteratorHelper(this.outletElementsByName.getValuesForKey(outletName)),
                _step10;

            try {
              for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                var element = _step10.value;

                var _iterator11 = _createForOfIteratorHelper(this.outletsByName.getValuesForKey(outletName)),
                    _step11;

                try {
                  for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                    var outlet = _step11.value;
                    this.disconnectOutlet(outlet, element, outletName);
                  }
                } catch (err) {
                  _iterator11.e(err);
                } finally {
                  _iterator11.f();
                }
              }
            } catch (err) {
              _iterator10.e(err);
            } finally {
              _iterator10.f();
            }
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
      }
    }, {
      key: "selector",
      value: function selector(outletName) {
        return this.scope.outlets.getSelectorForOutletName(outletName);
      }
    }, {
      key: "outletDependencies",
      get: function get() {
        var dependencies = new Multimap();
        this.router.modules.forEach(function (module) {
          var constructor = module.definition.controllerConstructor;
          var outlets = readInheritableStaticArrayValues(constructor, "outlets");
          outlets.forEach(function (outlet) {
            return dependencies.add(outlet, module.identifier);
          });
        });
        return dependencies;
      }
    }, {
      key: "outletDefinitions",
      get: function get() {
        return this.outletDependencies.getKeysForValue(this.identifier);
      }
    }, {
      key: "dependentControllerIdentifiers",
      get: function get() {
        return this.outletDependencies.getValuesForKey(this.identifier);
      }
    }, {
      key: "dependentContexts",
      get: function get() {
        var identifiers = this.dependentControllerIdentifiers;
        return this.router.contexts.filter(function (context) {
          return identifiers.includes(context.identifier);
        });
      }
    }, {
      key: "hasOutlet",
      value: function hasOutlet(element, outletName) {
        return !!this.getOutlet(element, outletName) || !!this.getOutletFromMap(element, outletName);
      }
    }, {
      key: "getOutlet",
      value: function getOutlet(element, outletName) {
        return this.application.getControllerForElementAndIdentifier(element, outletName);
      }
    }, {
      key: "getOutletFromMap",
      value: function getOutletFromMap(element, outletName) {
        return this.outletsByName.getValuesForKey(outletName).find(function (outlet) {
          return outlet.element === element;
        });
      }
    }, {
      key: "scope",
      get: function get() {
        return this.context.scope;
      }
    }, {
      key: "identifier",
      get: function get() {
        return this.context.identifier;
      }
    }, {
      key: "application",
      get: function get() {
        return this.context.application;
      }
    }, {
      key: "router",
      get: function get() {
        return this.application.router;
      }
    }]);

    return OutletObserver;
  }();

  var Context = /*#__PURE__*/function () {
    function Context(module, scope) {
      var _this14 = this;

      _classCallCheck(this, Context);

      this.logDebugActivity = function (functionName) {
        var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var identifier = _this14.identifier,
            controller = _this14.controller,
            element = _this14.element;
        detail = Object.assign({
          identifier: identifier,
          controller: controller,
          element: element
        }, detail);

        _this14.application.logDebugActivity(_this14.identifier, functionName, detail);
      };

      this.module = module;
      this.scope = scope;
      this.controller = new module.controllerConstructor(this);
      this.bindingObserver = new BindingObserver(this, this.dispatcher);
      this.valueObserver = new ValueObserver(this, this.controller);
      this.targetObserver = new TargetObserver(this, this);
      this.outletObserver = new OutletObserver(this, this);

      try {
        this.controller.initialize();
        this.logDebugActivity("initialize");
      } catch (error) {
        this.handleError(error, "initializing controller");
      }
    }

    _createClass(Context, [{
      key: "connect",
      value: function connect() {
        this.bindingObserver.start();
        this.valueObserver.start();
        this.targetObserver.start();
        this.outletObserver.start();

        try {
          this.controller.connect();
          this.logDebugActivity("connect");
        } catch (error) {
          this.handleError(error, "connecting controller");
        }
      }
    }, {
      key: "refresh",
      value: function refresh() {
        this.outletObserver.refresh();
      }
    }, {
      key: "disconnect",
      value: function disconnect() {
        try {
          this.controller.disconnect();
          this.logDebugActivity("disconnect");
        } catch (error) {
          this.handleError(error, "disconnecting controller");
        }

        this.outletObserver.stop();
        this.targetObserver.stop();
        this.valueObserver.stop();
        this.bindingObserver.stop();
      }
    }, {
      key: "application",
      get: function get() {
        return this.module.application;
      }
    }, {
      key: "identifier",
      get: function get() {
        return this.module.identifier;
      }
    }, {
      key: "schema",
      get: function get() {
        return this.application.schema;
      }
    }, {
      key: "dispatcher",
      get: function get() {
        return this.application.dispatcher;
      }
    }, {
      key: "element",
      get: function get() {
        return this.scope.element;
      }
    }, {
      key: "parentElement",
      get: function get() {
        return this.element.parentElement;
      }
    }, {
      key: "handleError",
      value: function handleError(error, message) {
        var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var identifier = this.identifier,
            controller = this.controller,
            element = this.element;
        detail = Object.assign({
          identifier: identifier,
          controller: controller,
          element: element
        }, detail);
        this.application.handleError(error, "Error ".concat(message), detail);
      }
    }, {
      key: "targetConnected",
      value: function targetConnected(element, name) {
        this.invokeControllerMethod("".concat(name, "TargetConnected"), element);
      }
    }, {
      key: "targetDisconnected",
      value: function targetDisconnected(element, name) {
        this.invokeControllerMethod("".concat(name, "TargetDisconnected"), element);
      }
    }, {
      key: "outletConnected",
      value: function outletConnected(outlet, element, name) {
        this.invokeControllerMethod("".concat(namespaceCamelize(name), "OutletConnected"), outlet, element);
      }
    }, {
      key: "outletDisconnected",
      value: function outletDisconnected(outlet, element, name) {
        this.invokeControllerMethod("".concat(namespaceCamelize(name), "OutletDisconnected"), outlet, element);
      }
    }, {
      key: "invokeControllerMethod",
      value: function invokeControllerMethod(methodName) {
        var controller = this.controller;

        if (typeof controller[methodName] == "function") {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key2 = 1; _key2 < _len; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          controller[methodName].apply(controller, args);
        }
      }
    }]);

    return Context;
  }();

  function bless(constructor) {
    return shadow(constructor, getBlessedProperties(constructor));
  }

  function shadow(constructor, properties) {
    var shadowConstructor = extend(constructor);
    var shadowProperties = getShadowProperties(constructor.prototype, properties);
    Object.defineProperties(shadowConstructor.prototype, shadowProperties);
    return shadowConstructor;
  }

  function getBlessedProperties(constructor) {
    var blessings = readInheritableStaticArrayValues(constructor, "blessings");
    return blessings.reduce(function (blessedProperties, blessing) {
      var properties = blessing(constructor);

      for (var key in properties) {
        var descriptor = blessedProperties[key] || {};
        blessedProperties[key] = Object.assign(descriptor, properties[key]);
      }

      return blessedProperties;
    }, {});
  }

  function getShadowProperties(prototype, properties) {
    return getOwnKeys(properties).reduce(function (shadowProperties, key) {
      var descriptor = getShadowedDescriptor(prototype, properties, key);

      if (descriptor) {
        Object.assign(shadowProperties, _defineProperty({}, key, descriptor));
      }

      return shadowProperties;
    }, {});
  }

  function getShadowedDescriptor(prototype, properties, key) {
    var shadowingDescriptor = Object.getOwnPropertyDescriptor(prototype, key);
    var shadowedByValue = shadowingDescriptor && "value" in shadowingDescriptor;

    if (!shadowedByValue) {
      var descriptor = Object.getOwnPropertyDescriptor(properties, key).value;

      if (shadowingDescriptor) {
        descriptor.get = shadowingDescriptor.get || descriptor.get;
        descriptor.set = shadowingDescriptor.set || descriptor.set;
      }

      return descriptor;
    }
  }

  var getOwnKeys = function () {
    if (typeof Object.getOwnPropertySymbols == "function") {
      return function (object) {
        return [].concat(_toConsumableArray(Object.getOwnPropertyNames(object)), _toConsumableArray(Object.getOwnPropertySymbols(object)));
      };
    } else {
      return Object.getOwnPropertyNames;
    }
  }();

  var extend = function () {
    function extendWithReflect(constructor) {
      function extended() {
        return Reflect.construct(constructor, arguments, this instanceof extended ? this.constructor : void 0);
      }

      extended.prototype = Object.create(constructor.prototype, {
        constructor: {
          value: extended
        }
      });
      Reflect.setPrototypeOf(extended, constructor);
      return extended;
    }

    function testReflectExtension() {
      var a = function a() {
        this.a.call(this);
      };

      var b = extendWithReflect(a);

      b.prototype.a = function () {};

      return new b();
    }

    try {
      testReflectExtension();
      return extendWithReflect;
    } catch (error) {
      return function (constructor) {
        return /*#__PURE__*/function (_constructor) {
          _inherits(extended, _constructor);

          var _super2 = _createSuper(extended);

          function extended() {
            _classCallCheck(this, extended);

            return _super2.apply(this, arguments);
          }

          return _createClass(extended);
        }(constructor);
      };
    }
  }();

  function blessDefinition(definition) {
    return {
      identifier: definition.identifier,
      controllerConstructor: bless(definition.controllerConstructor)
    };
  }

  var Module = /*#__PURE__*/function () {
    function Module(application, definition) {
      _classCallCheck(this, Module);

      this.application = application;
      this.definition = blessDefinition(definition);
      this.contextsByScope = new WeakMap();
      this.connectedContexts = new Set();
    }

    _createClass(Module, [{
      key: "identifier",
      get: function get() {
        return this.definition.identifier;
      }
    }, {
      key: "controllerConstructor",
      get: function get() {
        return this.definition.controllerConstructor;
      }
    }, {
      key: "contexts",
      get: function get() {
        return Array.from(this.connectedContexts);
      }
    }, {
      key: "connectContextForScope",
      value: function connectContextForScope(scope) {
        var context = this.fetchContextForScope(scope);
        this.connectedContexts.add(context);
        context.connect();
      }
    }, {
      key: "disconnectContextForScope",
      value: function disconnectContextForScope(scope) {
        var context = this.contextsByScope.get(scope);

        if (context) {
          this.connectedContexts.delete(context);
          context.disconnect();
        }
      }
    }, {
      key: "fetchContextForScope",
      value: function fetchContextForScope(scope) {
        var context = this.contextsByScope.get(scope);

        if (!context) {
          context = new Context(this, scope);
          this.contextsByScope.set(scope, context);
        }

        return context;
      }
    }]);

    return Module;
  }();

  var ClassMap = /*#__PURE__*/function () {
    function ClassMap(scope) {
      _classCallCheck(this, ClassMap);

      this.scope = scope;
    }

    _createClass(ClassMap, [{
      key: "has",
      value: function has(name) {
        return this.data.has(this.getDataKey(name));
      }
    }, {
      key: "get",
      value: function get(name) {
        return this.getAll(name)[0];
      }
    }, {
      key: "getAll",
      value: function getAll(name) {
        var tokenString = this.data.get(this.getDataKey(name)) || "";
        return tokenize(tokenString);
      }
    }, {
      key: "getAttributeName",
      value: function getAttributeName(name) {
        return this.data.getAttributeNameForKey(this.getDataKey(name));
      }
    }, {
      key: "getDataKey",
      value: function getDataKey(name) {
        return "".concat(name, "-class");
      }
    }, {
      key: "data",
      get: function get() {
        return this.scope.data;
      }
    }]);

    return ClassMap;
  }();

  var DataMap = /*#__PURE__*/function () {
    function DataMap(scope) {
      _classCallCheck(this, DataMap);

      this.scope = scope;
    }

    _createClass(DataMap, [{
      key: "element",
      get: function get() {
        return this.scope.element;
      }
    }, {
      key: "identifier",
      get: function get() {
        return this.scope.identifier;
      }
    }, {
      key: "get",
      value: function get(key) {
        var name = this.getAttributeNameForKey(key);
        return this.element.getAttribute(name);
      }
    }, {
      key: "set",
      value: function set(key, value) {
        var name = this.getAttributeNameForKey(key);
        this.element.setAttribute(name, value);
        return this.get(key);
      }
    }, {
      key: "has",
      value: function has(key) {
        var name = this.getAttributeNameForKey(key);
        return this.element.hasAttribute(name);
      }
    }, {
      key: "delete",
      value: function _delete(key) {
        if (this.has(key)) {
          var name = this.getAttributeNameForKey(key);
          this.element.removeAttribute(name);
          return true;
        } else {
          return false;
        }
      }
    }, {
      key: "getAttributeNameForKey",
      value: function getAttributeNameForKey(key) {
        return "data-".concat(this.identifier, "-").concat(dasherize(key));
      }
    }]);

    return DataMap;
  }();

  var Guide = /*#__PURE__*/function () {
    function Guide(logger) {
      _classCallCheck(this, Guide);

      this.warnedKeysByObject = new WeakMap();
      this.logger = logger;
    }

    _createClass(Guide, [{
      key: "warn",
      value: function warn(object, key, message) {
        var warnedKeys = this.warnedKeysByObject.get(object);

        if (!warnedKeys) {
          warnedKeys = new Set();
          this.warnedKeysByObject.set(object, warnedKeys);
        }

        if (!warnedKeys.has(key)) {
          warnedKeys.add(key);
          this.logger.warn(message, object);
        }
      }
    }]);

    return Guide;
  }();

  function attributeValueContainsToken(attributeName, token) {
    return "[".concat(attributeName, "~=\"").concat(token, "\"]");
  }

  var TargetSet = /*#__PURE__*/function () {
    function TargetSet(scope) {
      _classCallCheck(this, TargetSet);

      this.scope = scope;
    }

    _createClass(TargetSet, [{
      key: "element",
      get: function get() {
        return this.scope.element;
      }
    }, {
      key: "identifier",
      get: function get() {
        return this.scope.identifier;
      }
    }, {
      key: "schema",
      get: function get() {
        return this.scope.schema;
      }
    }, {
      key: "has",
      value: function has(targetName) {
        return this.find(targetName) != null;
      }
    }, {
      key: "find",
      value: function find() {
        var _this15 = this;

        for (var _len2 = arguments.length, targetNames = new Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
          targetNames[_key3] = arguments[_key3];
        }

        return targetNames.reduce(function (target, targetName) {
          return target || _this15.findTarget(targetName) || _this15.findLegacyTarget(targetName);
        }, undefined);
      }
    }, {
      key: "findAll",
      value: function findAll() {
        var _this16 = this;

        for (var _len3 = arguments.length, targetNames = new Array(_len3), _key4 = 0; _key4 < _len3; _key4++) {
          targetNames[_key4] = arguments[_key4];
        }

        return targetNames.reduce(function (targets, targetName) {
          return [].concat(_toConsumableArray(targets), _toConsumableArray(_this16.findAllTargets(targetName)), _toConsumableArray(_this16.findAllLegacyTargets(targetName)));
        }, []);
      }
    }, {
      key: "findTarget",
      value: function findTarget(targetName) {
        var selector = this.getSelectorForTargetName(targetName);
        return this.scope.findElement(selector);
      }
    }, {
      key: "findAllTargets",
      value: function findAllTargets(targetName) {
        var selector = this.getSelectorForTargetName(targetName);
        return this.scope.findAllElements(selector);
      }
    }, {
      key: "getSelectorForTargetName",
      value: function getSelectorForTargetName(targetName) {
        var attributeName = this.schema.targetAttributeForScope(this.identifier);
        return attributeValueContainsToken(attributeName, targetName);
      }
    }, {
      key: "findLegacyTarget",
      value: function findLegacyTarget(targetName) {
        var selector = this.getLegacySelectorForTargetName(targetName);
        return this.deprecate(this.scope.findElement(selector), targetName);
      }
    }, {
      key: "findAllLegacyTargets",
      value: function findAllLegacyTargets(targetName) {
        var _this17 = this;

        var selector = this.getLegacySelectorForTargetName(targetName);
        return this.scope.findAllElements(selector).map(function (element) {
          return _this17.deprecate(element, targetName);
        });
      }
    }, {
      key: "getLegacySelectorForTargetName",
      value: function getLegacySelectorForTargetName(targetName) {
        var targetDescriptor = "".concat(this.identifier, ".").concat(targetName);
        return attributeValueContainsToken(this.schema.targetAttribute, targetDescriptor);
      }
    }, {
      key: "deprecate",
      value: function deprecate(element, targetName) {
        if (element) {
          var identifier = this.identifier;
          var attributeName = this.schema.targetAttribute;
          var revisedAttributeName = this.schema.targetAttributeForScope(identifier);
          this.guide.warn(element, "target:".concat(targetName), "Please replace ".concat(attributeName, "=\"").concat(identifier, ".").concat(targetName, "\" with ").concat(revisedAttributeName, "=\"").concat(targetName, "\". ") + "The ".concat(attributeName, " attribute is deprecated and will be removed in a future version of Stimulus."));
        }

        return element;
      }
    }, {
      key: "guide",
      get: function get() {
        return this.scope.guide;
      }
    }]);

    return TargetSet;
  }();

  var OutletSet = /*#__PURE__*/function () {
    function OutletSet(scope, controllerElement) {
      _classCallCheck(this, OutletSet);

      this.scope = scope;
      this.controllerElement = controllerElement;
    }

    _createClass(OutletSet, [{
      key: "element",
      get: function get() {
        return this.scope.element;
      }
    }, {
      key: "identifier",
      get: function get() {
        return this.scope.identifier;
      }
    }, {
      key: "schema",
      get: function get() {
        return this.scope.schema;
      }
    }, {
      key: "has",
      value: function has(outletName) {
        return this.find(outletName) != null;
      }
    }, {
      key: "find",
      value: function find() {
        var _this18 = this;

        for (var _len4 = arguments.length, outletNames = new Array(_len4), _key5 = 0; _key5 < _len4; _key5++) {
          outletNames[_key5] = arguments[_key5];
        }

        return outletNames.reduce(function (outlet, outletName) {
          return outlet || _this18.findOutlet(outletName);
        }, undefined);
      }
    }, {
      key: "findAll",
      value: function findAll() {
        var _this19 = this;

        for (var _len5 = arguments.length, outletNames = new Array(_len5), _key6 = 0; _key6 < _len5; _key6++) {
          outletNames[_key6] = arguments[_key6];
        }

        return outletNames.reduce(function (outlets, outletName) {
          return [].concat(_toConsumableArray(outlets), _toConsumableArray(_this19.findAllOutlets(outletName)));
        }, []);
      }
    }, {
      key: "getSelectorForOutletName",
      value: function getSelectorForOutletName(outletName) {
        var attributeName = this.schema.outletAttributeForScope(this.identifier, outletName);
        return this.controllerElement.getAttribute(attributeName);
      }
    }, {
      key: "findOutlet",
      value: function findOutlet(outletName) {
        var selector = this.getSelectorForOutletName(outletName);
        if (selector) return this.findElement(selector, outletName);
      }
    }, {
      key: "findAllOutlets",
      value: function findAllOutlets(outletName) {
        var selector = this.getSelectorForOutletName(outletName);
        return selector ? this.findAllElements(selector, outletName) : [];
      }
    }, {
      key: "findElement",
      value: function findElement(selector, outletName) {
        var _this20 = this;

        var elements = this.scope.queryElements(selector);
        return elements.filter(function (element) {
          return _this20.matchesElement(element, selector, outletName);
        })[0];
      }
    }, {
      key: "findAllElements",
      value: function findAllElements(selector, outletName) {
        var _this21 = this;

        var elements = this.scope.queryElements(selector);
        return elements.filter(function (element) {
          return _this21.matchesElement(element, selector, outletName);
        });
      }
    }, {
      key: "matchesElement",
      value: function matchesElement(element, selector, outletName) {
        var controllerAttribute = element.getAttribute(this.scope.schema.controllerAttribute) || "";
        return element.matches(selector) && controllerAttribute.split(" ").includes(outletName);
      }
    }]);

    return OutletSet;
  }();

  var Scope = /*#__PURE__*/function () {
    function Scope(schema, element, identifier, logger) {
      var _this22 = this;

      _classCallCheck(this, Scope);

      this.targets = new TargetSet(this);
      this.classes = new ClassMap(this);
      this.data = new DataMap(this);

      this.containsElement = function (element) {
        return element.closest(_this22.controllerSelector) === _this22.element;
      };

      this.schema = schema;
      this.element = element;
      this.identifier = identifier;
      this.guide = new Guide(logger);
      this.outlets = new OutletSet(this.documentScope, element);
    }

    _createClass(Scope, [{
      key: "findElement",
      value: function findElement(selector) {
        return this.element.matches(selector) ? this.element : this.queryElements(selector).find(this.containsElement);
      }
    }, {
      key: "findAllElements",
      value: function findAllElements(selector) {
        return [].concat(_toConsumableArray(this.element.matches(selector) ? [this.element] : []), _toConsumableArray(this.queryElements(selector).filter(this.containsElement)));
      }
    }, {
      key: "queryElements",
      value: function queryElements(selector) {
        return Array.from(this.element.querySelectorAll(selector));
      }
    }, {
      key: "controllerSelector",
      get: function get() {
        return attributeValueContainsToken(this.schema.controllerAttribute, this.identifier);
      }
    }, {
      key: "isDocumentScope",
      get: function get() {
        return this.element === document.documentElement;
      }
    }, {
      key: "documentScope",
      get: function get() {
        return this.isDocumentScope ? this : new Scope(this.schema, document.documentElement, this.identifier, this.guide.logger);
      }
    }]);

    return Scope;
  }();

  var ScopeObserver = /*#__PURE__*/function () {
    function ScopeObserver(element, schema, delegate) {
      _classCallCheck(this, ScopeObserver);

      this.element = element;
      this.schema = schema;
      this.delegate = delegate;
      this.valueListObserver = new ValueListObserver(this.element, this.controllerAttribute, this);
      this.scopesByIdentifierByElement = new WeakMap();
      this.scopeReferenceCounts = new WeakMap();
    }

    _createClass(ScopeObserver, [{
      key: "start",
      value: function start() {
        this.valueListObserver.start();
      }
    }, {
      key: "stop",
      value: function stop() {
        this.valueListObserver.stop();
      }
    }, {
      key: "controllerAttribute",
      get: function get() {
        return this.schema.controllerAttribute;
      }
    }, {
      key: "parseValueForToken",
      value: function parseValueForToken(token) {
        var element = token.element,
            identifier = token.content;
        var scopesByIdentifier = this.fetchScopesByIdentifierForElement(element);
        var scope = scopesByIdentifier.get(identifier);

        if (!scope) {
          scope = this.delegate.createScopeForElementAndIdentifier(element, identifier);
          scopesByIdentifier.set(identifier, scope);
        }

        return scope;
      }
    }, {
      key: "elementMatchedValue",
      value: function elementMatchedValue(element, value) {
        var referenceCount = (this.scopeReferenceCounts.get(value) || 0) + 1;
        this.scopeReferenceCounts.set(value, referenceCount);

        if (referenceCount == 1) {
          this.delegate.scopeConnected(value);
        }
      }
    }, {
      key: "elementUnmatchedValue",
      value: function elementUnmatchedValue(element, value) {
        var referenceCount = this.scopeReferenceCounts.get(value);

        if (referenceCount) {
          this.scopeReferenceCounts.set(value, referenceCount - 1);

          if (referenceCount == 1) {
            this.delegate.scopeDisconnected(value);
          }
        }
      }
    }, {
      key: "fetchScopesByIdentifierForElement",
      value: function fetchScopesByIdentifierForElement(element) {
        var scopesByIdentifier = this.scopesByIdentifierByElement.get(element);

        if (!scopesByIdentifier) {
          scopesByIdentifier = new Map();
          this.scopesByIdentifierByElement.set(element, scopesByIdentifier);
        }

        return scopesByIdentifier;
      }
    }]);

    return ScopeObserver;
  }();

  var Router = /*#__PURE__*/function () {
    function Router(application) {
      _classCallCheck(this, Router);

      this.application = application;
      this.scopeObserver = new ScopeObserver(this.element, this.schema, this);
      this.scopesByIdentifier = new Multimap();
      this.modulesByIdentifier = new Map();
    }

    _createClass(Router, [{
      key: "element",
      get: function get() {
        return this.application.element;
      }
    }, {
      key: "schema",
      get: function get() {
        return this.application.schema;
      }
    }, {
      key: "logger",
      get: function get() {
        return this.application.logger;
      }
    }, {
      key: "controllerAttribute",
      get: function get() {
        return this.schema.controllerAttribute;
      }
    }, {
      key: "modules",
      get: function get() {
        return Array.from(this.modulesByIdentifier.values());
      }
    }, {
      key: "contexts",
      get: function get() {
        return this.modules.reduce(function (contexts, module) {
          return contexts.concat(module.contexts);
        }, []);
      }
    }, {
      key: "start",
      value: function start() {
        this.scopeObserver.start();
      }
    }, {
      key: "stop",
      value: function stop() {
        this.scopeObserver.stop();
      }
    }, {
      key: "loadDefinition",
      value: function loadDefinition(definition) {
        this.unloadIdentifier(definition.identifier);
        var module = new Module(this.application, definition);
        this.connectModule(module);
        var afterLoad = definition.controllerConstructor.afterLoad;

        if (afterLoad) {
          afterLoad(definition.identifier, this.application);
        }
      }
    }, {
      key: "unloadIdentifier",
      value: function unloadIdentifier(identifier) {
        var module = this.modulesByIdentifier.get(identifier);

        if (module) {
          this.disconnectModule(module);
        }
      }
    }, {
      key: "getContextForElementAndIdentifier",
      value: function getContextForElementAndIdentifier(element, identifier) {
        var module = this.modulesByIdentifier.get(identifier);

        if (module) {
          return module.contexts.find(function (context) {
            return context.element == element;
          });
        }
      }
    }, {
      key: "handleError",
      value: function handleError(error, message, detail) {
        this.application.handleError(error, message, detail);
      }
    }, {
      key: "createScopeForElementAndIdentifier",
      value: function createScopeForElementAndIdentifier(element, identifier) {
        return new Scope(this.schema, element, identifier, this.logger);
      }
    }, {
      key: "scopeConnected",
      value: function scopeConnected(scope) {
        this.scopesByIdentifier.add(scope.identifier, scope);
        var module = this.modulesByIdentifier.get(scope.identifier);

        if (module) {
          module.connectContextForScope(scope);
        }
      }
    }, {
      key: "scopeDisconnected",
      value: function scopeDisconnected(scope) {
        this.scopesByIdentifier.delete(scope.identifier, scope);
        var module = this.modulesByIdentifier.get(scope.identifier);

        if (module) {
          module.disconnectContextForScope(scope);
        }
      }
    }, {
      key: "connectModule",
      value: function connectModule(module) {
        this.modulesByIdentifier.set(module.identifier, module);
        var scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
        scopes.forEach(function (scope) {
          return module.connectContextForScope(scope);
        });
      }
    }, {
      key: "disconnectModule",
      value: function disconnectModule(module) {
        this.modulesByIdentifier.delete(module.identifier);
        var scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
        scopes.forEach(function (scope) {
          return module.disconnectContextForScope(scope);
        });
      }
    }]);

    return Router;
  }();

  var defaultSchema = {
    controllerAttribute: "data-controller",
    actionAttribute: "data-action",
    targetAttribute: "data-target",
    targetAttributeForScope: function targetAttributeForScope(identifier) {
      return "data-".concat(identifier, "-target");
    },
    outletAttributeForScope: function outletAttributeForScope(identifier, outlet) {
      return "data-".concat(identifier, "-").concat(outlet, "-outlet");
    },
    keyMappings: Object.assign(Object.assign({
      enter: "Enter",
      tab: "Tab",
      esc: "Escape",
      space: " ",
      up: "ArrowUp",
      down: "ArrowDown",
      left: "ArrowLeft",
      right: "ArrowRight",
      home: "Home",
      end: "End"
    }, objectFromEntries("abcdefghijklmnopqrstuvwxyz".split("").map(function (c) {
      return [c, c];
    }))), objectFromEntries("0123456789".split("").map(function (n) {
      return [n, n];
    })))
  };

  function objectFromEntries(array) {
    return array.reduce(function (memo, _ref22) {
      var _ref23 = _slicedToArray(_ref22, 2),
          k = _ref23[0],
          v = _ref23[1];

      return Object.assign(Object.assign({}, memo), _defineProperty({}, k, v));
    }, {});
  }

  var Application = /*#__PURE__*/function () {
    function Application() {
      var _this23 = this;

      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.documentElement;
      var schema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultSchema;

      _classCallCheck(this, Application);

      this.logger = console;
      this.debug = false;

      this.logDebugActivity = function (identifier, functionName) {
        var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        if (_this23.debug) {
          _this23.logFormattedMessage(identifier, functionName, detail);
        }
      };

      this.element = element;
      this.schema = schema;
      this.dispatcher = new Dispatcher(this);
      this.router = new Router(this);
      this.actionDescriptorFilters = Object.assign({}, defaultActionDescriptorFilters);
    }

    _createClass(Application, [{
      key: "start",
      value: function () {
        var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return domReady();

                case 2:
                  this.logDebugActivity("application", "starting");
                  this.dispatcher.start();
                  this.router.start();
                  this.logDebugActivity("application", "start");

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function start() {
          return _start.apply(this, arguments);
        }

        return start;
      }()
    }, {
      key: "stop",
      value: function stop() {
        this.logDebugActivity("application", "stopping");
        this.dispatcher.stop();
        this.router.stop();
        this.logDebugActivity("application", "stop");
      }
    }, {
      key: "register",
      value: function register(identifier, controllerConstructor) {
        this.load({
          identifier: identifier,
          controllerConstructor: controllerConstructor
        });
      }
    }, {
      key: "registerActionOption",
      value: function registerActionOption(name, filter) {
        this.actionDescriptorFilters[name] = filter;
      }
    }, {
      key: "load",
      value: function load(head) {
        var _this24 = this;

        for (var _len6 = arguments.length, rest = new Array(_len6 > 1 ? _len6 - 1 : 0), _key7 = 1; _key7 < _len6; _key7++) {
          rest[_key7 - 1] = arguments[_key7];
        }

        var definitions = Array.isArray(head) ? head : [head].concat(rest);
        definitions.forEach(function (definition) {
          if (definition.controllerConstructor.shouldLoad) {
            _this24.router.loadDefinition(definition);
          }
        });
      }
    }, {
      key: "unload",
      value: function unload(head) {
        var _this25 = this;

        for (var _len7 = arguments.length, rest = new Array(_len7 > 1 ? _len7 - 1 : 0), _key8 = 1; _key8 < _len7; _key8++) {
          rest[_key8 - 1] = arguments[_key8];
        }

        var identifiers = Array.isArray(head) ? head : [head].concat(rest);
        identifiers.forEach(function (identifier) {
          return _this25.router.unloadIdentifier(identifier);
        });
      }
    }, {
      key: "controllers",
      get: function get() {
        return this.router.contexts.map(function (context) {
          return context.controller;
        });
      }
    }, {
      key: "getControllerForElementAndIdentifier",
      value: function getControllerForElementAndIdentifier(element, identifier) {
        var context = this.router.getContextForElementAndIdentifier(element, identifier);
        return context ? context.controller : null;
      }
    }, {
      key: "handleError",
      value: function handleError(error, message, detail) {
        var _a;

        this.logger.error("%s\n\n%o\n\n%o", message, error, detail);
        (_a = window.onerror) === null || _a === void 0 ? void 0 : _a.call(window, message, "", 0, 0, error);
      }
    }, {
      key: "logFormattedMessage",
      value: function logFormattedMessage(identifier, functionName) {
        var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        detail = Object.assign({
          application: this
        }, detail);
        this.logger.groupCollapsed("".concat(identifier, " #").concat(functionName));
        this.logger.log("details:", Object.assign({}, detail));
        this.logger.groupEnd();
      }
    }], [{
      key: "start",
      value: function start(element, schema) {
        var application = new this(element, schema);
        application.start();
        return application;
      }
    }]);

    return Application;
  }();

  function domReady() {
    return new Promise(function (resolve) {
      if (document.readyState == "loading") {
        document.addEventListener("DOMContentLoaded", function () {
          return resolve();
        });
      } else {
        resolve();
      }
    });
  }

  function ClassPropertiesBlessing(constructor) {
    var classes = readInheritableStaticArrayValues(constructor, "classes");
    return classes.reduce(function (properties, classDefinition) {
      return Object.assign(properties, propertiesForClassDefinition(classDefinition));
    }, {});
  }

  function propertiesForClassDefinition(key) {
    var _ref24;

    return _ref24 = {}, _defineProperty(_ref24, "".concat(key, "Class"), {
      get: function get() {
        var classes = this.classes;

        if (classes.has(key)) {
          return classes.get(key);
        } else {
          var attribute = classes.getAttributeName(key);
          throw new Error("Missing attribute \"".concat(attribute, "\""));
        }
      }
    }), _defineProperty(_ref24, "".concat(key, "Classes"), {
      get: function get() {
        return this.classes.getAll(key);
      }
    }), _defineProperty(_ref24, "has".concat(capitalize(key), "Class"), {
      get: function get() {
        return this.classes.has(key);
      }
    }), _ref24;
  }

  function OutletPropertiesBlessing(constructor) {
    var outlets = readInheritableStaticArrayValues(constructor, "outlets");
    return outlets.reduce(function (properties, outletDefinition) {
      return Object.assign(properties, propertiesForOutletDefinition(outletDefinition));
    }, {});
  }

  function propertiesForOutletDefinition(name) {
    var _ref25;

    var camelizedName = namespaceCamelize(name);
    return _ref25 = {}, _defineProperty(_ref25, "".concat(camelizedName, "Outlet"), {
      get: function get() {
        var outlet = this.outlets.find(name);

        if (outlet) {
          var outletController = this.application.getControllerForElementAndIdentifier(outlet, name);

          if (outletController) {
            return outletController;
          } else {
            throw new Error("Missing \"data-controller=".concat(name, "\" attribute on outlet element for \"").concat(this.identifier, "\" controller"));
          }
        }

        throw new Error("Missing outlet element \"".concat(name, "\" for \"").concat(this.identifier, "\" controller"));
      }
    }), _defineProperty(_ref25, "".concat(camelizedName, "Outlets"), {
      get: function get() {
        var _this26 = this;

        var outlets = this.outlets.findAll(name);

        if (outlets.length > 0) {
          return outlets.map(function (outlet) {
            var controller = _this26.application.getControllerForElementAndIdentifier(outlet, name);

            if (controller) {
              return controller;
            } else {
              console.warn("The provided outlet element is missing the outlet controller \"".concat(name, "\" for \"").concat(_this26.identifier, "\""), outlet);
            }
          }).filter(function (controller) {
            return controller;
          });
        }

        return [];
      }
    }), _defineProperty(_ref25, "".concat(camelizedName, "OutletElement"), {
      get: function get() {
        var outlet = this.outlets.find(name);

        if (outlet) {
          return outlet;
        } else {
          throw new Error("Missing outlet element \"".concat(name, "\" for \"").concat(this.identifier, "\" controller"));
        }
      }
    }), _defineProperty(_ref25, "".concat(camelizedName, "OutletElements"), {
      get: function get() {
        return this.outlets.findAll(name);
      }
    }), _defineProperty(_ref25, "has".concat(capitalize(camelizedName), "Outlet"), {
      get: function get() {
        return this.outlets.has(name);
      }
    }), _ref25;
  }

  function TargetPropertiesBlessing(constructor) {
    var targets = readInheritableStaticArrayValues(constructor, "targets");
    return targets.reduce(function (properties, targetDefinition) {
      return Object.assign(properties, propertiesForTargetDefinition(targetDefinition));
    }, {});
  }

  function propertiesForTargetDefinition(name) {
    var _ref26;

    return _ref26 = {}, _defineProperty(_ref26, "".concat(name, "Target"), {
      get: function get() {
        var target = this.targets.find(name);

        if (target) {
          return target;
        } else {
          throw new Error("Missing target element \"".concat(name, "\" for \"").concat(this.identifier, "\" controller"));
        }
      }
    }), _defineProperty(_ref26, "".concat(name, "Targets"), {
      get: function get() {
        return this.targets.findAll(name);
      }
    }), _defineProperty(_ref26, "has".concat(capitalize(name), "Target"), {
      get: function get() {
        return this.targets.has(name);
      }
    }), _ref26;
  }

  function ValuePropertiesBlessing(constructor) {
    var valueDefinitionPairs = readInheritableStaticObjectPairs(constructor, "values");
    var propertyDescriptorMap = {
      valueDescriptorMap: {
        get: function get() {
          var _this27 = this;

          return valueDefinitionPairs.reduce(function (result, valueDefinitionPair) {
            var valueDescriptor = parseValueDefinitionPair(valueDefinitionPair, _this27.identifier);

            var attributeName = _this27.data.getAttributeNameForKey(valueDescriptor.key);

            return Object.assign(result, _defineProperty({}, attributeName, valueDescriptor));
          }, {});
        }
      }
    };
    return valueDefinitionPairs.reduce(function (properties, valueDefinitionPair) {
      return Object.assign(properties, propertiesForValueDefinitionPair(valueDefinitionPair));
    }, propertyDescriptorMap);
  }

  function propertiesForValueDefinitionPair(valueDefinitionPair, controller) {
    var _ref27;

    var definition = parseValueDefinitionPair(valueDefinitionPair, controller);
    var key = definition.key,
        name = definition.name,
        read = definition.reader,
        write = definition.writer;
    return _ref27 = {}, _defineProperty(_ref27, name, {
      get: function get() {
        var value = this.data.get(key);

        if (value !== null) {
          return read(value);
        } else {
          return definition.defaultValue;
        }
      },
      set: function set(value) {
        if (value === undefined) {
          this.data.delete(key);
        } else {
          this.data.set(key, write(value));
        }
      }
    }), _defineProperty(_ref27, "has".concat(capitalize(name)), {
      get: function get() {
        return this.data.has(key) || definition.hasCustomDefaultValue;
      }
    }), _ref27;
  }

  function parseValueDefinitionPair(_ref28, controller) {
    var _ref29 = _slicedToArray(_ref28, 2),
        token = _ref29[0],
        typeDefinition = _ref29[1];

    return valueDescriptorForTokenAndTypeDefinition({
      controller: controller,
      token: token,
      typeDefinition: typeDefinition
    });
  }

  function parseValueTypeConstant(constant) {
    switch (constant) {
      case Array:
        return "array";

      case Boolean:
        return "boolean";

      case Number:
        return "number";

      case Object:
        return "object";

      case String:
        return "string";
    }
  }

  function parseValueTypeDefault(defaultValue) {
    switch (_typeof(defaultValue)) {
      case "boolean":
        return "boolean";

      case "number":
        return "number";

      case "string":
        return "string";
    }

    if (Array.isArray(defaultValue)) return "array";
    if (Object.prototype.toString.call(defaultValue) === "[object Object]") return "object";
  }

  function parseValueTypeObject(payload) {
    var typeFromObject = parseValueTypeConstant(payload.typeObject.type);
    if (!typeFromObject) return;
    var defaultValueType = parseValueTypeDefault(payload.typeObject.default);

    if (typeFromObject !== defaultValueType) {
      var propertyPath = payload.controller ? "".concat(payload.controller, ".").concat(payload.token) : payload.token;
      throw new Error("The specified default value for the Stimulus Value \"".concat(propertyPath, "\" must match the defined type \"").concat(typeFromObject, "\". The provided default value of \"").concat(payload.typeObject.default, "\" is of type \"").concat(defaultValueType, "\"."));
    }

    return typeFromObject;
  }

  function parseValueTypeDefinition(payload) {
    var typeFromObject = parseValueTypeObject({
      controller: payload.controller,
      token: payload.token,
      typeObject: payload.typeDefinition
    });
    var typeFromDefaultValue = parseValueTypeDefault(payload.typeDefinition);
    var typeFromConstant = parseValueTypeConstant(payload.typeDefinition);
    var type = typeFromObject || typeFromDefaultValue || typeFromConstant;
    if (type) return type;
    var propertyPath = payload.controller ? "".concat(payload.controller, ".").concat(payload.typeDefinition) : payload.token;
    throw new Error("Unknown value type \"".concat(propertyPath, "\" for \"").concat(payload.token, "\" value"));
  }

  function defaultValueForDefinition(typeDefinition) {
    var constant = parseValueTypeConstant(typeDefinition);
    if (constant) return defaultValuesByType[constant];
    var defaultValue = typeDefinition.default;
    if (defaultValue !== undefined) return defaultValue;
    return typeDefinition;
  }

  function valueDescriptorForTokenAndTypeDefinition(payload) {
    var key = "".concat(dasherize(payload.token), "-value");
    var type = parseValueTypeDefinition(payload);
    return {
      type: type,
      key: key,
      name: camelize(key),

      get defaultValue() {
        return defaultValueForDefinition(payload.typeDefinition);
      },

      get hasCustomDefaultValue() {
        return parseValueTypeDefault(payload.typeDefinition) !== undefined;
      },

      reader: readers[type],
      writer: writers[type] || writers.default
    };
  }

  var defaultValuesByType = {
    get array() {
      return [];
    },

    boolean: false,
    number: 0,

    get object() {
      return {};
    },

    string: ""
  };
  var readers = {
    array: function array(value) {
      var array = JSON.parse(value);

      if (!Array.isArray(array)) {
        throw new TypeError("expected value of type \"array\" but instead got value \"".concat(value, "\" of type \"").concat(parseValueTypeDefault(array), "\""));
      }

      return array;
    },
    boolean: function boolean(value) {
      return !(value == "0" || String(value).toLowerCase() == "false");
    },
    number: function number(value) {
      return Number(value);
    },
    object: function object(value) {
      var object = JSON.parse(value);

      if (object === null || _typeof(object) != "object" || Array.isArray(object)) {
        throw new TypeError("expected value of type \"object\" but instead got value \"".concat(value, "\" of type \"").concat(parseValueTypeDefault(object), "\""));
      }

      return object;
    },
    string: function string(value) {
      return value;
    }
  };
  var writers = {
    default: writeString,
    array: writeJSON,
    object: writeJSON
  };

  function writeJSON(value) {
    return JSON.stringify(value);
  }

  function writeString(value) {
    return "".concat(value);
  }

  var Controller = /*#__PURE__*/function () {
    function Controller(context) {
      _classCallCheck(this, Controller);

      this.context = context;
    }

    _createClass(Controller, [{
      key: "application",
      get: function get() {
        return this.context.application;
      }
    }, {
      key: "scope",
      get: function get() {
        return this.context.scope;
      }
    }, {
      key: "element",
      get: function get() {
        return this.scope.element;
      }
    }, {
      key: "identifier",
      get: function get() {
        return this.scope.identifier;
      }
    }, {
      key: "targets",
      get: function get() {
        return this.scope.targets;
      }
    }, {
      key: "outlets",
      get: function get() {
        return this.scope.outlets;
      }
    }, {
      key: "classes",
      get: function get() {
        return this.scope.classes;
      }
    }, {
      key: "data",
      get: function get() {
        return this.scope.data;
      }
    }, {
      key: "initialize",
      value: function initialize() {}
    }, {
      key: "connect",
      value: function connect() {}
    }, {
      key: "disconnect",
      value: function disconnect() {}
    }, {
      key: "dispatch",
      value: function dispatch(eventName) {
        var _ref30 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref30$target = _ref30.target,
            target = _ref30$target === void 0 ? this.element : _ref30$target,
            _ref30$detail = _ref30.detail,
            detail = _ref30$detail === void 0 ? {} : _ref30$detail,
            _ref30$prefix = _ref30.prefix,
            prefix = _ref30$prefix === void 0 ? this.identifier : _ref30$prefix,
            _ref30$bubbles = _ref30.bubbles,
            bubbles = _ref30$bubbles === void 0 ? true : _ref30$bubbles,
            _ref30$cancelable = _ref30.cancelable,
            cancelable = _ref30$cancelable === void 0 ? true : _ref30$cancelable;

        var type = prefix ? "".concat(prefix, ":").concat(eventName) : eventName;
        var event = new CustomEvent(type, {
          detail: detail,
          bubbles: bubbles,
          cancelable: cancelable
        });
        target.dispatchEvent(event);
        return event;
      }
    }], [{
      key: "shouldLoad",
      get: function get() {
        return true;
      }
    }, {
      key: "afterLoad",
      value: function afterLoad(_identifier, _application) {
        return;
      }
    }]);

    return Controller;
  }();

  Controller.blessings = [ClassPropertiesBlessing, TargetPropertiesBlessing, ValuePropertiesBlessing, OutletPropertiesBlessing];
  Controller.targets = [];
  Controller.outlets = [];
  Controller.values = {};
  exports.Application = Application;
  exports.AttributeObserver = AttributeObserver;
  exports.Context = Context;
  exports.Controller = Controller;
  exports.ElementObserver = ElementObserver;
  exports.IndexedMultimap = IndexedMultimap;
  exports.Multimap = Multimap;
  exports.SelectorObserver = SelectorObserver;
  exports.StringMapObserver = StringMapObserver;
  exports.TokenListObserver = TokenListObserver;
  exports.ValueListObserver = ValueListObserver;
  exports.add = _add;
  exports.defaultSchema = defaultSchema;
  exports.del = del;
  exports.fetch = fetch;
  exports.prune = prune;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});